import React, { useState } from "react";
import { MapContainer, TileLayer, Circle, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { MapPin, Search, Loader2, CheckCircle2, XCircle } from "lucide-react";
import axios from "axios";

export const HQ = { lat: 50.4057385, lng: 2.6415378 };
export const RADIUS_KM = 40;
export const CITIES = ["Arras", "Lens", "Liévin", "Béthune", "Bruay-la-Buissière", "Nœux-les-Mines", "Avion", "Hénin-Beaumont", "Carvin", "Saint-Pol-sur-Ternoise", "Lillers", "Douai", "Seclin", "Aire-sur-la-Lys", "Bapaume", "Armentières", "Lille"];

const pin = L.divIcon({ className: "", iconSize: [22, 22], iconAnchor: [11, 22], html: '<div style="width:22px;height:22px;border-radius:50% 50% 50% 0;background:#1e50ff;transform:rotate(-45deg);border:3px solid #fff;box-shadow:0 2px 6px rgba(0,0,0,.35)"></div>' });

export const ZoneMap = () => (
  <div className="rounded-2xl overflow-hidden border border-neutral-200 shadow-sm h-[380px] md:h-[460px]" data-testid="zone-map">
    <MapContainer center={[HQ.lat, HQ.lng]} zoom={9} scrollWheelZoom={false} style={{ height: "100%", width: "100%" }}>
      <TileLayer attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
      <Circle center={[HQ.lat, HQ.lng]} radius={RADIUS_KM * 1000} pathOptions={{ color: "#16a34a", fillColor: "#22c55e", fillOpacity: 0.15, weight: 2 }} />
      <Marker position={[HQ.lat, HQ.lng]} icon={pin}><Popup>Siège PTITSERVICES-PRO — 62530 Servins<br />Zone espaces verts : {RADIUS_KM} km</Popup></Marker>
    </MapContainer>
  </div>
);

const zoneMessage = (res) => {
  if (!res.found) return res.message;
  if (res.in_zone) return `Oui ! À ${res.distance_km} km de notre siège : nous intervenons chez vous.`;
  return `À ${res.distance_km} km, vous êtes hors de notre zone espaces verts (${res.radius_km} km). Contactez-nous, une exception reste possible.`;
};

const ZoneResult = ({ res }) => {
  const ok = res.found && res.in_zone;
  return (
    <p className={`mt-3 text-sm font-semibold flex items-center gap-1.5 ${ok ? "text-emerald-700" : "text-amber-700"}`} data-testid="zone-result">
      {ok ? <CheckCircle2 size={16} /> : <XCircle size={16} />} {zoneMessage(res)}
    </p>
  );
};

export const ZoneChecker = () => {
  const [q, setQ] = useState("");
  const [res, setRes] = useState(null);
  const [busy, setBusy] = useState(false);
  const check = async (e) => {
    e.preventDefault();
    if (q.trim().length < 2) return;
    setBusy(true);
    try {
      const r = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/public/zone-check`, { params: { q: q.trim() } });
      setRes(r.data);
    } catch {
      setRes({ found: false, message: "Vérification indisponible, réessayez." });
    } finally { setBusy(false); }
  };
  return (
    <div className="bg-white border border-neutral-200 rounded-2xl p-5" data-testid="zone-checker">
      <p className="font-heading font-bold text-neutral-900 flex items-center gap-2"><MapPin size={16} className="text-emerald-600" /> Votre site est-il dans notre zone ?</p>
      <form onSubmit={check} className="flex gap-2 mt-3">
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Ville ou code postal (ex : 62000 Arras)" className="flex-1 border border-neutral-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:border-emerald-600" data-testid="zone-input" />
        <button type="submit" disabled={busy} className="bg-emerald-600 hover:bg-emerald-700 text-white font-semibold px-4 rounded-md flex items-center gap-1.5 disabled:opacity-60" data-testid="zone-submit">
          {busy ? <Loader2 size={15} className="animate-spin" /> : <Search size={15} />} Vérifier
        </button>
      </form>
      {res && <ZoneResult res={res} />}
    </div>
  );
};
